export const transition = (i: number) => ({
  transition: {
    delay: i * 0.2,
    duration: 0.4,
    ease: 'easeInOut',
  },
});
